import {
  getGradingCommentTemplatesField,
  getLearningCourseField,
} from "./modules/utils";

const IbMypCurriculumProgramPolicy = {
  IbMypCurriculumProgram: {
    fields: {
      gradingCommentTemplates: getGradingCommentTemplatesField(),
      learningCourse: getLearningCourseField(),
    },
  },
};

export default IbMypCurriculumProgramPolicy;
